const { toZonedTime, fromZonedTime } = require('date-fns-tz');

const zoneDate = (params = Date.now()) => fromZonedTime(new Date(params), 'Europe/Amsterdam');

const zoneDateFromUTC = (params = Date.now()) => fromZonedTime(new Date(params), 'UTC');

module.exports = { zoneDate, zoneDateFromUTC };
